import { render } from "./account-mapping-actions.vue?vue&type=template&id=f46900ca"
import script from "./account-mapping-actions.vue?vue&type=script&lang=js"
export * from "./account-mapping-actions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__